module.exports = __webpack_public_path__ + "assets/img/busy_10.9e86a2d2.png";